<template>
  <div class="card">
    <div class="card-header">
      <h5 style="display: flex; justify-content: space-between;">
        <span>
          <i class="fa fa-desktop"></i>
          {{ $t('mats') }}
        </span>
        <span>
          <i class="fa fa-external-link mr-2" v-on:click="externalLink()"></i>
          <i class="fa fa-refresh onRefresh ml-2" v-on:click="refresh()"></i>
        </span>
      </h5>
      <hr>
    </div>

    <div class="card-body">
      <div v-if="isLoading" class="text-center">
        <i class="fa fa-cog fa-spin fa-fw fa-huge text-warning"></i>
      </div>
      <div class="text-center mb-4"
             v-if="!isLoading && mat_metrics.length == 0 && mat_inactive.length == 0">
        <i class="fa fa-thumbs-up fa-2x text-success"></i><strong>All good!</strong>
      </div>
      <table v-else-if="!isLoading" class="table">
        <thead>
          <tr>
            <th>{{ $t('mattxt') }}</th>
            <th class="text-center">ram %</th>
            <th class="text-center">cpu %</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in mat_metrics" v-on:click="openMat(item.id)" class="rowOnHover">
            <td>
              <i class="fa fa-android robot-icon mr-1"/> {{ item.name}}
            </td>
            <td class="text-center pl-4">{{ item.ram_percent}} %</td>
            <td class="text-center pl-4">{{ item.cpu_percent }} %</td>
          </tr>
          <tr v-for="item in mat_inactive"  v-on:click="openMat(item.id)" class="rowOnHover">
            <td>
              <i class="fa fa-android robot-icon mr-1"/> {{ item.name}}
            </td>
            <td class="text-center pl-4"> OFF </td>
            <td class="text-center pl-4"> OFF </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>


</template>
<script>
export default {
  name: "MatMatricsWidget",
  props:{ },
  data() {
    return {
      mat_metrics: [],
      mat_inactive: [],
      isLoading: true
    }
  },
  methods: {
    openMat(matId) {
      location.href = "/admin_strategies/mat/" + matId;
    },
    externalLink() {
      window.open(" https://app.pulseboard.hokocloud.com?pass=th1s1s4n3w4w3s0m3d4sh!", "_blank");
    },
    refresh(){
      this.isLoading = true
      this.getMetrics()
    },
    getMetrics() {
      let success = resp => {
        this.mat_metrics = [...resp.data.high_cpu, ...resp.data.high_ram]
        this.mat_inactive = [... resp.data.inactive_robot]
        this.isLoading = false
      }
      let fail = resp => {
        console.log(resp)
      }
      this.$getMatWidgetMetrics().then(success, fail)
    }
  },
  mounted() {
    this.getMetrics()
  }
}
</script>
<style scoped>
  tbody {
      display: block;
      max-height: 50vh;
      overflow: auto;
  }
  thead, tbody tr {
      display: table;
      width: 100%;
      table-layout: fixed;
  }
  .robot-icon {
    color: #F56C6C
  }
  .onRefresh:hover {
    animation: spin 1s linear infinite;
  }
  .rowOnHover:hover {
    font-weight: bold;
  }

@keyframes spin {
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
